import { Avatar } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { siteInfo } from "../utils/SiteInfo";
import {
  CloudServerOutlined,
  GoldOutlined,
  HomeOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { Tooltip } from "antd";
import {
  IoCashOutline,
  IoChatbox,
  IoChatboxOutline,
  IoChatbubblesOutline,
  IoCloseCircle,
} from "react-icons/io5";
export default function Navbar(props) {
  let profile = useSelector((state) => state.auth?.profile);

  let accessCrm = localStorage.getItem("accessCrm")
    ? JSON.parse(localStorage.getItem("accessCrm"))
    : null;

  const location = useLocation();

  let routes = [
    {
      path: "/",
      title: "Dashboard",
      icon: HomeOutlined,
    },
    {
      path: "/purchasing",
      title: "Purchasing",
      icon: CloudServerOutlined,
    },
    {
      path: "/orders",
      title: "Orders",
      icon: GoldOutlined,
    },
    {
      path: "/customers",
      title: "Customers",
      icon: TeamOutlined,
    },
    {
      path: "/payments",
      title: "Payments",
      icon: IoCashOutline,
    },
    {
      path: "/admins",
      title: "Admins",
      icon: UsergroupAddOutlined,
    },
  ];

  const auth = useSelector((state) => state.auth);

  const getRouteName = (pathname) => {
    let found = routes.find((el) => el.path === pathname);
    if (found) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <found.icon size={18} color="#fff" />
          <span
            style={{
              color: "#fff",
              marginLeft: 8,
              textTransform: "capitalize",
            }}
          >
            {found.title}
          </span>
        </div>
      );
    } else {
      let arr = pathname.split("/");
      let name = arr[arr.length - 1];

      console.log(name);

      name =
        name && typeof name === "string" ? name?.split("-").join(" ") : name;

      if (pathname.includes("/create-post")) {
        name = "Create Post";
      }
      if (pathname.includes("/edit-post")) {
        name = "Edit Post";
      }
      if (pathname.includes("/delivery/")) {
        name = "Invoice";
      }
      if (pathname.includes("/cash-counter/")) {
        name = "Cash Counter";
      }
      if (pathname.includes("/campaign/")) {
        name = "Campaign Details";
      }
      if (pathname.includes("agent/orders")) {
        name = "Agent Orders";
      }
      if (pathname.includes("/agent/withdraw/")) {
        name = "Agent Withdraw";
      }

      if (pathname.includes("/skyexpress-bookings")) {
        name = "SkyExpress Bookings";
      }
      if (pathname.includes("/crm/customer")) {
        name = "Customer Details";
      }

      if (pathname === "/purchasing") {
        name = "Air Purchase";
      }

      if (pathname.includes("/shipping-categories")) {
        name = "Shipping Categories";
      }

      if (pathname.includes("/my-crm")) {
        name = "My CRM";
        if (pathname.length > 10) {
          name = "Manager CRM";
        }
      }
      if (pathname.includes("/bulk-order-carton-list")) {
        name = "Bulk Order Carton List";
      }
      if (pathname.includes("/gallery/")) {
        name = "Image Gallery";
      }

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ color: "#fff", textTransform: "capitalize" }}>
            {name}
          </span>
        </div>
      );
    }
  };

  return (
    <>
      {location.pathname !== "/login" && (
        <nav
          style={{
            background: `linear-gradient(90deg, ${siteInfo.navColor} 50%, #056b3b)`,
            padding: "0px 1.5rem",
            position: "fixed",
            boxShadow: "0 1px 16px rgba(0,0,0,.1)",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            zIndex: 1,
            height: "60px",
            color: "white",
            top: 0,
            left: 0,
            right: 0,
            display: auth?.isAuthenticated ? "block" : "none",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a className="flex align-center justify-center" href="/">
                <img
                  style={{ width: "100px" }}
                  src={require("../assets/logo2.png")}
                  alt=""
                />
              </a>
              {/* {getRouteName(location.pathname)} */}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {
                <Link
                  to="/chat"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    style={{
                      backgroundColor: "#ffffffff",
                      color: siteInfo.navColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    icon={<IoChatboxOutline size={20} />}
                  />
                </Link>
              }

              {accessCrm ? (
                <div
                  className="flex align-center"
                  style={{
                    gap: 8,
                    background: "#E4004B",
                    borderRadius: 12,
                    padding: "4px 8px",
                    cursor: "pointer",
                    marginLeft: 12
                  }}
                  onClick={() => {
                    localStorage.removeItem("accessCrm");
                    window.location.href = "/";
                  }}
                >
                  <Avatar
                    style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}
                  >
                    {accessCrm?.crm?.manager_type}
                  </Avatar>
                  <div>
                    <p>Accessing CRM</p>
                    <p
                      style={{
                        fontSize: 12,
                      }}
                    >
                      {accessCrm?.name}
                    </p>
                  </div>
                  <IoCloseCircle size={24} color="#fff" />
                </div>
              ) : (
                <Link to="/profile" className="logout">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Avatar
                      style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}
                    >
                      U
                    </Avatar>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        marginLeft: "0.5rem",
                      }}
                    >
                      <span
                        style={{
                          lineHeight: "18px",
                          fontWeight: "bold",
                          color: "#f0f0f0",
                        }}
                      >
                        {profile?.name ? profile?.name : "Administration"}
                      </span>
                      <span
                        style={{
                          lineHeight: "18px",
                          fontWeight: "bold",
                          color: "#eee",
                          fontSize: 12,
                          textTransform: "capitalize",
                        }}
                      >
                        {profile?.phone ? profile?.phone : "role"}
                      </span>
                    </div>
                  </div>
                </Link>
              )}
            </div>
          </div>
        </nav>
      )}
    </>
  );
}
